// @flow

import styled  from 'styled-components';

export const Title = styled.p`
  font-size: 22px;
  font-family: ${props => props.theme.fontFamily.display};
  color: #2397d4;
  margin-bottom: 16px;
`;
